import axios from "axios";
import localForage from "localforage";
import {
	host_url,
	host_api_omni_point,
	micro_service_host,
} from "../app-config";

export const POST = async (requestUrl, requestData, headers) => {
	let errorCode;
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error("An error occured. Please try again");
		}
		const response = await axios.post(
			`${host_url}${requestUrl}`,
			requestData,
			requestHeaders,
		);
		if (response.data.StatusCode === 1) {
			return response.data.Result;
		} else {
			errorCode = response.data.StatusCode;
			if (
				response.data.ErrorMessage &&
				response.data.ErrorMessage.toLowerCase() !== "internal server error"
			) {
				throw new Error(response.data.ErrorMessage);
			} else {
				throw new Error("An error occured. Please try again");
			}
		}
	} catch (error) {
		return {
			error: {
				message:
					error.message === "Network Error"
						? "Please check your internet connection and try again"
						: error.message,
				errorCode,
			},
		};
	}
};

export const GET = async (requestUrl, headers, cancelToken) => {
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error(1);
		}
		let config = {
			headers: requestHeaders.headers,
		};
		if (cancelToken) {
			config.cancelToken = cancelToken;
		}
		const response = await axios(`${host_url}${requestUrl}`, config);
		if (response.data.StatusCode === 1) {
			return response.data.Result;
		} else {
			if (
				response.data.ErrorMessage &&
				response.data.ErrorMessage.toLowerCase() !== "internal server error"
			) {
				throw new Error(response.data.ErrorMessage);
			} else {
				throw new Error("An error occured. Please try again");
			}
			//throw new Error(2);
		}
	} catch (error) {
		return { error: { type: error } };
	}
};

export const MSPOST = async (requestUrl, requestData, headers) => {
	let errorCode;
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error("An error occured. Please try again");
		}

		const response = await axios.post(
			`${micro_service_host}${requestUrl}`,
			requestData,
			requestHeaders,
		);

		if (response.data.StatusCode === "OK") {
			return response.data.Data;
		} else {
			errorCode = response.data.StatusCode;
			return response.data.Message;
		}
	} catch (error) {
		errorCode = error.response.data.StatusCode;
		return {
			error: {
				message:
					error.message === "Network Error"
						? "Please check your internet connection and try again"
						: error.response.data.Message,
				errorCode,
				errors: error.response.data.Errors
					? Object.values(error.response.data.Errors)
					: error.response.data.Message,
			},
		};
	}
};

export const MSGET = async (requestUrl, headers, cancelToken) => {
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error(1);
		}
		let config = {
			headers: requestHeaders.headers,
		};
		if (cancelToken) {
			config.cancelToken = cancelToken;
		}

		const response = await axios(`${micro_service_host}${requestUrl}`, config);

		if (response.data.StatusCode === "OK") {
			return response.data.Data;
		} else if (response.status === 200) {
			return response.data;
		} else {
			if (
				response.data.ErrorMessage &&
				response.data.ErrorMessage.toLowerCase() !== "internal server error"
			) {
				throw new Error(response.data.ErrorMessage);
			} else {
				throw new Error("An error occured. Please try again");
			}
			//throw new Error(2);
		}
	} catch (error) {
		return {
			error: {
				message:
					error.message === "Network Error"
						? "Please check your internet connection and try again"
						: error.response.data.Message,
				errors: error.response.data.Errors
					? Object.values(error.response.data.Errors)
					: error.response.data.Message,
			},
		};
	}
};

export const MSPUT = async (requestUrl, requestData, headers) => {
	let errorCode;
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error("An error occured. Please try again");
		}

		const response = await axios.put(
			`${micro_service_host}${requestUrl}`,
			requestData,
			requestHeaders,
		);

		if (response.data.StatusCode === "OK") {
			return response.data.Data;
		} else {
			errorCode = response.data.StatusCode;
			return response.data.Message;
		}
	} catch (error) {
		errorCode = error.response.data.StatusCode;
		return {
			error: {
				message:
					error.message === "Network Error"
						? "Please check your internet connection and try again"
						: error.response.data.Message,
				errorCode,
				errors: error.response.data.Errors
					? Object.values(error.response.data.Errors)
					: error.response.data.Message,
			},
		};
	}
};

export const MSDELETE = async (requestUrl, headers, cancelToken) => {
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error(1);
		}
		let config = {
			headers: requestHeaders.headers,
		};
		if (cancelToken) {
			config.cancelToken = cancelToken;
		}

		const response = await axios.delete(
			`${micro_service_host}${requestUrl}`,
			config,
		);

		if (response.data.StatusCode === "OK") {
			return response.data.Data;
		} else {
			if (
				response.data.ErrorMessage &&
				response.data.ErrorMessage.toLowerCase() !== "internal server error"
			) {
				throw new Error(response.data.ErrorMessage);
			} else {
				throw new Error("An error occured. Please try again");
			}
			//throw new Error(2);
		}
	} catch (error) {
		return { error: { type: error } };
	}
};

//TODO: Need to delete after completing task
export const GETOmni = async (requestUrl, headers, cancelToken) => {
	try {
		const requestHeaders = headers || (await localForage.getItem("jsonHeader"));
		if (!requestHeaders) {
			throw new Error(1);
		}
		let config = {
			headers: requestHeaders.headers,
		};
		if (cancelToken) {
			config.cancelToken = cancelToken;
		}
		const response = await axios(`${host_api_omni_point}${requestUrl}`, config);
		if (response.data.StatusCode === "OK" && response.data.Errors === null) {
			return response.data.Data;
		} else {
			throw new Error(2);
		}
	} catch (error) {
		return { error: { type: error } };
	}
};
